import { Phone } from "lucide-react";

const FAQS = [
  {
    q: "What vaccinations do you require?",
    a: "Dogs need Rabies, Distemper, and Bordetella. Cats need Rabies and FVRCP. Bring proof on first visit.",
  },
  {
    q: "What should I bring for boarding?",
    a: "Your pet's food (pre-portioned), familiar bedding, any medications with instructions, and vaccination records.",
  },
  {
    q: "Do you groom cats?",
    a: "Yes — we're one of the few groomers in Moose Jaw that takes cats. We handle all temperaments with patience.",
  },
  {
    q: "What should I expect on my first drop-off?",
    a: "Plan for a quick intake conversation so we can learn about your pet's personality and your preferences.",
  },
];

export default function FAQSection() {
  return (
    <section className="faq" data-testid="faq-section">
      <div className="faq__inner">
        <div className="faq__copy">
          <span className="overline" >QUESTIONS</span>
          <h2 className="section-h2">Things first-time visitors ask.</h2>
          <p className="faq__lead">Don't see your question? Call us.</p>
          <a href="tel:3066910001" className="pp-btn-primary" data-testid="faq-phone-cta">
            <Phone className="w-4 h-4" />
            306-691-0001
          </a>
        </div>
        <div className="faq__list">
          {FAQS.map((item) => (
            <details key={item.q} className="faq__item" data-testid={`faq-item-${item.q.slice(0, 20).replace(/\W+/g, "-")}`}>
              <summary>
                <span>{item.q}</span>
                <span className="faq__plus" aria-hidden>+</span>
              </summary>
              <p className="faq__answer">{item.a}</p>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}
